import { Box, Divider, HStack, Text } from 'native-base'
import React, { PropsWithChildren } from 'react'

export const HorizontalDivider: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box>
      <HStack justifyContent={'center'} alignItems={'center'}>
        {children ? (
          <>
            <Divider bg="gray.700" thickness="1" flex={1} />
            <Text textTransform={'uppercase'} mx="2" color={'gray.700'} fontWeight={'bold'}>
              {children}
            </Text>
            <Divider bg="gray.700" thickness="1" flex={1} />
          </>
        ) : (
          <Divider bg="gray.700" thickness="1" flex={1} />
        )}
      </HStack>
    </Box>
  )
}
